import axios from 'axios'

const state = () => ({
  rahbariyat: []
})

const getters = {
  rahbariyat(state) {
    return state.rahbariyat
  }
}

const mutations = {
  SET_RAHBARIYAT(state, payload){
    state.rahbariyat = payload
  },
  DELETE_RAHBARIYAT(state, id){
    state.rahbariyat = state.rahbariyat.filter((x) => x.id != id);
  },
  ADD_RAHBARIYAT(state, data){
    state.rahbariyat.push(data);
  },
  EDIT_RAHBARIYAT(state, payload){
    state.rahbariyat = state.rahbariyat.map((vm)=>{
      if(vm.id == payload.id){return payload}
      else{ return vm }
    })
  }
}

const actions = {
  getRahbariyat({commit}){
    axios.get('https://api.geomalaka.uz/api/employee/rahbariyat/')
    .then((res)=>{
      commit("SET_RAHBARIYAT", res.data)
      // this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteRahbariyat({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/employee/rahbariyat/${id}/`)
    .then((res)=>{
      commit("DELETE_RAHBARIYAT", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addRahbariyat({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/employee/rahbariyat/', payload)
    .then((res)=>{
      commit("ADD_RAHBARIYAT", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editRahbariyat({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/employee/rahbariyat/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_RAHBARIYAT", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

